import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";


@Component({
    selector: 'charla-priority',
    templateUrl: 'priority.component.html',
    styleUrls: ['priority.component.scss'],
    imports: [CommonModule, NgbDropdownModule]
  })
  export class CharlaPriorityComponent {

    @Input() priority: number;
    @Output() public change: EventEmitter<any> = new EventEmitter();
    lookup: string[] = ["Low Priority", "Normal Priority", "High Priority"]; 

    constructor(
    ){

    }

    set_priority(priority: number){
        this.change.emit( priority );
    }



  }